import { useEffect, useState } from 'react';
import { RELEASE } from './content';

/*
 * Механика установки: скачивание APK и QR-код.
 *
 * Вынесены отдельно от модального окна, потому что нужны и ему, и странице
 * установки, а тащить ради двух функций всё окно с его состоянием — значит
 * связывать страницу инструкции с модалкой, которой на ней нет.
 */

/**
 * Скачивание APK через невидимую ссылку.
 *
 * Нужна именно ссылка с `download`, а не переход по адресу: переход на
 * страницу инструкции сразу после этого не прерывает начавшуюся загрузку,
 * а смена location — прерывает.
 */
export function triggerApkDownload() {
  const a = document.createElement('a');
  a.href = RELEASE.apk;
  a.download = `aura-${RELEASE.version}.apk`;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/**
 * QR для переноса установки на телефон.
 *
 * Библиотека подгружается динамически: она нужна только на широком экране и
 * только когда окно установки открыто, а весит заметно больше самого кода
 * окна. Ошибку глотаем — без QR окно остаётся рабочим.
 */
export function QrTile({ url, size = 96, fallback = null }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let alive = true;
    import('qrcode')
      .then((QR) =>
        QR.toDataURL(url, {
          margin: 0,
          width: size * 2,
          color: { dark: '#0a0b0d', light: '#ffffff' },
        })
      )
      .then((dataUrl) => alive && setSrc(dataUrl))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [url, size]);

  return (
    <span className="im__qr" style={{ width: size, height: size }}>
      {src ? <img src={src} alt={`QR-код на ${url}`} /> : fallback}
    </span>
  );
}
